module.exports = __webpack_public_path__ + "img/img03.444f1681.png";